export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=404f2a3d64534fb4598ff96046b128a780932fa0d1&name=addToFolderEventAction!'